import styled, { css } from 'styled-components';

type ContainerProps = {
  allHeight?: boolean;
};

export const LoadingContainer = styled.div<ContainerProps>`
  ${({ allHeight }) => {
    if (allHeight) {
      return css`
        display: flex;
        height: 100%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: auto;
        margin-left: auto;
      `;
    }
    return 'height: 100px;';
  }}
`;

export const LoadingText = styled.p`
  font-family: ${({ theme }) => theme.fonts.primaryFont};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.commentGrey};
  text-align: center;
`;
